import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { auth0Domain, auth0Audience, auth0ClientId, isDevelopment } from '../../config';

export const Auth0ProviderWithHistory = ({ children }) => {
    const navigate = useNavigate();

    const onRedirectCallback = (appState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    if (!(auth0Domain && auth0ClientId && auth0Audience)) {
        return null;
    }

    return (
        <Auth0Provider
            domain={auth0Domain}
            clientId={auth0ClientId}
            cacheLocation={isDevelopment ? 'localstorage' : 'memory'}
            useRefreshTokens={isDevelopment}
            authorizationParams={{
                redirect_uri: window.location.origin + '/dashboard',
                audience: auth0Audience,
                scope: isDevelopment ? 'openid profile email offline_access' : 'openid profile email',
            }}
            onRedirectCallback={onRedirectCallback}
        >
            {children}
        </Auth0Provider>
    );
};
